import { VisualSlice, ArenaStoreState, ActiveTrickVisualState } from '../arenaStoreTypes';
import { SeatPosition } from '../../state/ArenaTypes';

export type StoreSet = (
  partial: Partial<ArenaStoreState> | ((state: ArenaStoreState) => Partial<ArenaStoreState>)
) => void;
export type StoreGet = () => ArenaStoreState;

export const initialVisualState = {
  lastLocalPlayedCardId: null as string | null,
  scheduledDealingHand: null as number | null,
  hasFinalizedHand: null as number | null,
  isDealingAnimationActive: false,
  wasDealingAnimationActive: false,
  isDealingInitiated: false,
  lastAnimatedHand: null as number | null,
  activeDealingDealerSeat: null as SeatPosition | null,
  activeDealKey: null as string | null,
  activeTrickVisual: null as ActiveTrickVisualState | null,
  sweptTrickKeys: [] as string[],
  isUserDraggingCard: false,
  isHudHidden: false,
  isTableMenuOpen: false,
  isScoreModalOpen: false,
};

export const createVisualSlice = (set: StoreSet, _get: StoreGet): VisualSlice => ({
  ...initialVisualState,

  setLastLocalPlayedCardId: (lastLocalPlayedCardId) => set({ lastLocalPlayedCardId }),
  setScheduledDealingHand: (scheduledDealingHand) => set({ scheduledDealingHand }),
  setHasFinalizedHand: (hasFinalizedHand) => set({ hasFinalizedHand }),
  setDealingAnimationActive: (isDealingAnimationActive) => set({ isDealingAnimationActive }),
  setWasDealingAnimationActive: (wasDealingAnimationActive) => set({ wasDealingAnimationActive }),
  setDealingInitiated: (isDealingInitiated) => set({ isDealingInitiated }),
  setLastAnimatedHand: (lastAnimatedHand) => set({ lastAnimatedHand }),
  setActiveDealingDealerSeat: (activeDealingDealerSeat) => set({ activeDealingDealerSeat }),
  setActiveDealKey: (activeDealKey) => set({ activeDealKey }),

  // Trick Visual Actions
  setActiveTrickVisual: (updater) =>
    set((state) => ({
      activeTrickVisual: typeof updater === 'function' ? updater(state.activeTrickVisual) : updater,
    })),
  setTrickIsSweeping: (isSweeping) =>
    set((state) => ({
      activeTrickVisual: state.activeTrickVisual ? { ...state.activeTrickVisual, isSweeping } : null,
    })),
  addSweptTrickKey: (trickKey) =>
    set((state) => ({
      sweptTrickKeys: state.sweptTrickKeys.includes(trickKey)
        ? state.sweptTrickKeys
        : [...state.sweptTrickKeys, trickKey],
    })),
  clearTrickVisualState: () =>
    set({
      activeTrickVisual: null,
      sweptTrickKeys: [],
    }),

  // Active User Drag / Interaction Actions
  setIsUserDraggingCard: (isUserDraggingCard) => set({ isUserDraggingCard }),

  // HUD Visibility Actions
  setIsHudHidden: (isHudHidden) => set({ isHudHidden }),
  toggleHudHidden: () => set((state) => ({ isHudHidden: !state.isHudHidden })),

  // Table Menu & Score Modal Actions
  setIsTableMenuOpen: (isTableMenuOpen) => set({ isTableMenuOpen }),
  toggleTableMenu: () => set((state) => ({ isTableMenuOpen: !state.isTableMenuOpen })),
  setIsScoreModalOpen: (isScoreModalOpen) => set({ isScoreModalOpen }),
  toggleScoreModal: () => set((state) => ({ isScoreModalOpen: !state.isScoreModalOpen })),
});
